import React, { useState } from "react";
import { toast } from "react-toastify";
import { createProduct, updateProduct } from "../../utils/api";
import CustomModal, { ModalInput, ModalSelect } from "../Modal";
import Success from "../Success";

const ProductModal = ({ open, setOpen, reload, update, data, setProduct }) => {
  const [loading, setLoading] = useState(false);
  const [newProduct, setNewProduct] = useState({});
  const [success, setSuccess] = useState(false);
  const createCustomerHandler = async () => {
    if (
      !newProduct.productName ||
      !newProduct.productType ||
      !newProduct.tax ||
      !newProduct.group ||
      !newProduct.rate ||
      !newProduct.hsn ||
      !newProduct.units
    ) {
      alert("Please fill all the fields");
      return;
    }

    // Only include description if it has a value
    const productData = { ...newProduct };
    if (!productData.description) {
      delete productData.description;
    }

    setLoading(true);
    if (update) {
      const [success, data] = await updateProduct(newProduct?._id, productData);
      if (success) {
        setNewProduct({});
        setProduct((prev) => ({
          ...prev,
          product: newProduct,
        }));
        setSuccess(true);
        setOpen(false);
        toast.success("Product Updated Successfully");
      } else {
        toast.error(data?.response?.data?.message || "Something went wrong");
      }
    } else {
      const [success, data] = await createProduct(productData);
      console.log(data);
      if (success) {
        setNewProduct({});
        reload();
        setSuccess(true);
        setOpen(false);
        toast.success("Product Created Successfully");
      } else {
        toast.error(data?.response?.data?.message || "Something went wrong");
      }
    }
    setLoading(false);
  };

  React.useEffect(() => {
    if (update) {
      setNewProduct(data);
    }
  }, [update, data]);
  return (
    <>
      <CustomModal
        open={open}
        setOpen={setOpen}
        loading={loading}
        onClick={createCustomerHandler}
      >
        <ModalInput
          title="Product Name"
          value={newProduct?.productName}
          onChange={(e) => {
            setNewProduct({
              ...newProduct,
              productName: e.target.value,
            });
          }}
        />
        <ModalSelect
          title="GST(%)"
          options={["0", "5", "12", "18"]}
          value={newProduct?.tax}
          onChange={(e) => {
            setNewProduct({
              ...newProduct,
              tax: e.target.value,
            });
          }}
        />
        <ModalSelect
          title="TYPE"
          options={["Sale", "Purchase"]}
          value={newProduct?.productType}
          onChange={(e) => {
            setNewProduct({
              ...newProduct,
              productType: e.target.value,
            });
          }}
        />

        <ModalSelect
          title="Group"
          options={["Tag", "Stancil", "Trading", "Other"]}
          value={newProduct?.group}
          onChange={(e) => {
            setNewProduct({
              ...newProduct,
              group: e.target.value,
            });
          }}
        />
        <ModalInput
          title="Rate"
          type="number"
          value={newProduct?.rate}
          onChange={(e) => {
            setNewProduct({
              ...newProduct,
              rate: e.target.value,
            });
          }}
        />
        <ModalInput
          title="HSN"
          type="number"
          value={newProduct?.hsn}
          onChange={(e) => {
            setNewProduct({
              ...newProduct,
              hsn: e.target.value,
            });
          }}
        />
        <ModalInput
          title="Units"
          value={newProduct?.units}
          onChange={(e) => {
            setNewProduct({
              ...newProduct,
              units: e.target.value,
            });
          }}
        />
        <ModalInput
          title="Description (Optional)"
          value={newProduct?.description}
          onChange={(e) => {
            setNewProduct({
              ...newProduct,
              description: e.target.value,
            });
          }}
        />
      </CustomModal>
      {success && <Success />}
    </>
  );
};

export default ProductModal;
